module.exports = __webpack_public_path__ + "img/167.0dc326ad.jpg";